import { Text } from '@chakra-ui/react';

import { VisaStatus } from 'types';

import { IVisaStatus } from '../../../../../../../types';

interface IProps {
  visaStatus: IVisaStatus;
}
export const IntroWrapper = ({ visaStatus }: IProps) => {
  visaStatus = visaStatus || VisaStatus.NONE;
  let statusEl = <></>;

  switch (visaStatus) {
    case VisaStatus.NONE: {
      return (
        <>
          <Text>
            You have not entered a visa status. Once you enter your status you will be able to return and update it if
            it changes.
          </Text>
        </>
      );
    }
    case VisaStatus.CAS_NOT_RECEIVED: {
      statusEl = (
        <>
          you have <b>not received your CAS document</b>
        </>
      );
      break;
    }
    case VisaStatus.VISA_RECEIVED: {
      statusEl = (
        <>
          you have <b>received your visa</b>
        </>
      );
      break;
    }
    case VisaStatus.INTENDS_TO_DEFER: {
      statusEl = (
        <>
          you <b>intend to defer</b>
        </>
      );
      break;
    }
    case VisaStatus.INTENDS_TO_WITHDRAW: {
      statusEl = (
        <>
          you <b>intend to withdraw</b>
        </>
      );
      break;
    }
    case VisaStatus.VISA_REFUSAL: {
      statusEl = (
        <>
          you have <b>received a visa refusal</b>
        </>
      );
      break;
    }
    case VisaStatus.UKVI_REQUEST_MORE_INFO: {
      statusEl = (
        <>
          <b>UKVI has requested more information from you</b>
        </>
      );
      break;
    }
    case VisaStatus.AWAITING_VISA_RESPONSE: {
      statusEl = (
        <>
          you are <b>still waiting to hear back from UKVI</b>
        </>
      );
      break;
    }

    case VisaStatus.VISA_APPLIED: {
      statusEl = (
        <>
          you have <b>applied for your visa</b>
        </>
      );
      break;
    }
    case VisaStatus.CAS_RECEIVED: {
      statusEl = (
        <>
          you have <b>your CAS but haven't applied for your visa yet</b>
        </>
      );
      break;
    }
    default: {
      statusEl = <></>;
    }
  }

  return (
    <>
      <Text>You have told us {statusEl}. If that is correct you do not have to do anything on this page.</Text>

      <Text>If your visa situation has changed, please let us know by completing this page.</Text>
    </>
  );
};
